import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { NotificationManager } from "react-notifications";
import { ListadoPTApi } from "./api/ListadoPTApi";
import Paginacion from "../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { FiltrosPT } from "./components/FiltrosPT";
import { TablePT } from "./components/TablePT";
import { useDebounce } from "../../../../../Utils/Hooks/useDebounce";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import "./styles/ListadoPT.css";

export const ListadoPT = ({ storageKey }) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const searchDefault = filtros.search || "";

    const { control, watch } = useForm({
        defaultValues: {
            search: searchDefault,
        },
    });

    const [registrosPT, setRegistrosPT] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);

    const { getRegistrosPT, deletePT, cargando } = ListadoPTApi();

    const GetRegistrosPT = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            const response = await getRegistrosPT(params);
            setRegistrosPT(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            console.log("Error al obtener registrosPT:", error);
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las registrosPT",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setRegistrosPT([]);
            setCantidadResultados(0);
        }
    };

    const EliminarPT = async (id) => {
        try {
            await deletePT(id);
            NotificationManager.success(
                "Producto terminado eliminado correctamente",
                "Éxito",
                3000,
            );
            GetRegistrosPT();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar producto terminado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        GetRegistrosPT();
    }, [debouncedSearch, paginaSeleccionada]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                search: debouncedSearch,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [debouncedSearch, paginaSeleccionada]);

    return (
        <div className="listado-pt__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div className="listado-pt__table-header">
                        <FiltrosPT
                            control={control}
                            onRefresh={() => {
                                GetRegistrosPT();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                            searchPlaceholder={"Producto"}
                        />
                        <Link to={`/producto-terminado/crear`}>
                            <button className="btn btn-primary">
                                Crear producto terminado
                            </button>
                        </Link>
                    </div>

                    <TablePT
                        registrosPT={registrosPT}
                        EliminarPT={EliminarPT}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
